import { css, cx } from '@emotion/css';

const cn = {
  container: css`
    display: flex;
    flex-direction: column;
    padding: 0px 16px;
    @media (max-width: 800px) {
      padding: 0px 8px;
    }
  `,
};

interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const PageContent: React.FC<PageContentProps> = ({ children, className, ...props }) => {
  return (
    <div className={cx(cn.container, className)} {...props}>
      {children}
    </div>
  );
};

PageContent.displayName = 'PageContent';
